export type StatItem = {
  value: string;
  labelKey: string;
};

export const stats: StatItem[] = [
  { value: "104+", labelKey: "stat_publicaciones" },
  { value: "03",   labelKey: "stat_patentes" },
  { value: "15",   labelKey: "stat_proyectos" },
  { value: "05",   labelKey: "stat_alianzas" },
];